// toastBridge.jsx
let notifier = null;

export function registerNotifier(instance) {
  notifier = instance;
}

export function notifyError({
  message,
  description = null,
  key = null,
  duration = 3,
} = {}) {
  if (notifier) {
    notifier.errorMessage({ message, description, key, duration });
  }
}
export function notifySuccess({
  message,
  description = null,
  key = null,
  duration = 0,
} = {}) {
  if (notifier) {
    notifier.successMessage({ message, description, key, duration });
  }
}
